import React from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import "./index.css";
import assets from "../../../../../util/assets";
import CreateGalleryPage from "../../../../../container/broadcaster/MyLibrary/CreateGalleryPage";
import PropTypes from "prop-types";

const GalleryModal = (props) => {

    return (
        <Modal isOpen={props.isOpen} className="gallery-modal">
            <ModalHeader className="border-0 " id="upload-file-modal">
                <span className="text-center mb-2 modal-container-title">
                    {props.title}
                </span>
                <img src={assets.broadcast.cross}
                     alt={"cross icon"}
                     onClick={() => {
                         props.toggle();
                     }}/>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                <CreateGalleryPage
                    history={props.history}
                    editMode={props.hasOwnProperty("editMode") ? props.editMode : false}
                    toggle={props.toggle}/>
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">

            </ModalFooter>
        </Modal>
    );
}

GalleryModal.propTypes = {
    title: PropTypes.string,
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    history: PropTypes.object,
};

export default GalleryModal;